<template>
    <section class="equipmentConfirmationSection">
        <header class="sectionHeader">
                    <div class="pageTitle"
                         v-if="hasEquipment">{{ areaOfConcern.name }} secured</div>
                    <div class="pageTitle"
                         v-if="!hasEquipment">You can protect this later</div>
                </header>
        <!-- Non Accessible Windows -->
        <div v-if="!hasEquipment">
            <div class="noAccessibleWindowsWarning">
                <div class="warningImage">
                    <img src="/img/warning.png"
                         alt="Warning">
                </div>
                <div class="warningTitle">No protection selected</div>
                <div class="warningText">
                    Add protection later by viewing
                    <div class="trueAdvice"><span class="true">TRUE</span>Advice</div>
                </div>
            </div>
        </div>

        <!-- Confirmation -->
        <div v-if="hasEquipment"
             class="noAccessibleWindowsWarning hasEquipment">
            <div class="warningImage">
                <img src="/img/shield-checkmark.png"
                     alt="Confirmed">
            </div>
            <div class="warningTitle">{{ areaOfConcern.name }} secured</div>
            <div class="warningText">
                We added this equipment to your system
            </div>
        </div>

        <section v-if="chosen"
                 class="areaEquipmentSection">
            <true-panel class="area-equipment-panel selected">
                <div class="equipment-listing">
                    <div class="equipment-listing-image">
                        <img :src="chosen.item.image"
                             :alt="chosen.item.name">
                    </div>
                    <div class="equipment-listing-title">
                        <div class="equipment-listing-label">{{ chosenName }}</div>
                        <div class="equipment-listing-name">
                            {{ chosen.qty }} {{ chosen.item.name }}{{ chosen.qty > 1 ? 's' : '' }}
                        </div>
                        <div class="equipment-listing-location">
                            <b>${{ (chosen.item.price * chosen.qty).toLocaleString('en') }}</b> / ${{ chosen.item.price.toLocaleString('en') }} ea
                        </div>
                    </div>
                    <div class="">
                        <img class="checkmark"
                             src="/img/checkmark-white.png"
                             alt="Checkmark">
                    </div>
                </div>
            </true-panel>
        </section>

    </section>
</template>

<script>
import { mapActions, mapState } from "vuex"
export default {
    computed: {
        ...mapState(["areaOfConcern"]),

        recommended() {
            return this.areaOfConcern.equipmentOptions.recommended
        },

        alternative() {
            return this.areaOfConcern.equipmentOptions.alternative
        },

        hasEquipment() {
            let keys = Object.keys(this.areaOfConcern.equipmentOptions)
            let length = keys.length
            return length > 0
        },

        chosenName() {
            return this.areaOfConcern.equipmentOptionChosen
        },

        chosen() {
            let selected = this.chosenName
            return this.areaOfConcern.equipmentOptions[selected]
        }
    },
    methods: {
        ...mapActions([])
    }
}
</script>

<style lang="css"></style>
